/**
 * @generated SignedSource<<11e892d2d349246bcc0ed5c34a873dda>>
 * @relayHash 16dda89a8ff214b88ce294908d978fb4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 998a008a7fee1762972b118a7f82c5dc3a050ee23863ab74af199df44c0fb4e8

import type { ConcreteRequest } from 'relay-runtime';
export type useLabelsSelectPropsLabelSearchQuery$variables = {
  contentId: string;
  searchText: string;
};
export type useLabelsSelectPropsLabelSearchQuery$data = {
  readonly contentLabelSearch: {
    readonly otherLabels: ReadonlyArray<{
      readonly id: string | null;
      readonly label: string | null;
      readonly name: string | null;
      readonly prefix: string | null;
    } | null>;
    readonly suggestedLabels: ReadonlyArray<{
      readonly id: string | null;
      readonly label: string | null;
      readonly name: string | null;
      readonly prefix: string | null;
    } | null>;
  } | null;
};
export type useLabelsSelectPropsLabelSearchQuery = {
  response: useLabelsSelectPropsLabelSearchQuery$data;
  variables: useLabelsSelectPropsLabelSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchText"
  }
],
v1 = [
  {
    "kind": "ScalarField",
    "name": "prefix"
  },
  {
    "kind": "ScalarField",
    "name": "name"
  },
  {
    "kind": "ScalarField",
    "name": "id"
  },
  {
    "kind": "ScalarField",
    "name": "label"
  }
],
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "searchText",
        "variableName": "searchText"
      }
    ],
    "concreteType": "LabelSearchResults",
    "kind": "LinkedField",
    "name": "contentLabelSearch",
    "plural": false,
    "selections": [
      {
        "concreteType": "Label",
        "kind": "LinkedField",
        "name": "suggestedLabels",
        "plural": true,
        "selections": (v1/*: any*/)
      },
      {
        "concreteType": "Label",
        "kind": "LinkedField",
        "name": "otherLabels",
        "plural": true,
        "selections": (v1/*: any*/)
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useLabelsSelectPropsLabelSearchQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useLabelsSelectPropsLabelSearchQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "16dda89a8ff214b88ce294908d978fb4",
    "id": "998a008a7fee1762972b118a7f82c5dc3a050ee23863ab74af199df44c0fb4e8",
    "metadata": {},
    "name": "useLabelsSelectPropsLabelSearchQuery",
    "operationKind": "query",
    "text": "query useLabelsSelectPropsLabelSearchQuery($contentId:ID!,$searchText:String!){contentLabelSearch(contentId:$contentId,searchText:$searchText){suggestedLabels{prefix,name,id,label},otherLabels{prefix,name,id,label}}}"
  }
};
})();

(node as any).hash = "c4b7037cf05dc5bb933ddd918075cdc8";

export default node;
